import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./TeamSectionByInnovera.module.scss";
import { CaretDownIcon, UserIcon } from "@/frontend/shared/assets/icons";
import { SectionContentWrapper } from "@/frontend/widgets/SectionContentWrapper/SectionContentWrapper";
import { NormalButton } from "@/frontend/shared/ui/Button";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { LinkedInLettersIcon } from "@/frontend/shared/assets/icons/LinkedInLettersIcon";
import { InnoveraBlockNoData } from "@/frontend/features/Company/ui/InnoveraBlockNoData/InnoveraBlockNoData";
import { TTeamMember } from "@/frontend/features/Company/model/types/types";
import { SectionLoader } from "../../Section/SectionLoader/SectionLoader";

export type TTeamSectionByInnoveraProps = {
  onReportError?: () => void;
  teamData?: TTeamMember[];
  isLoadingTeamData: boolean;
};

export function TeamSectionByInnovera({
  onReportError,
  teamData,
  isLoadingTeamData: isLoading
}: TTeamSectionByInnoveraProps) {
  const [isTeamMemberShown, setIsTeamMemberShown] = useState(false);

  const [shownData, setShownData] = useState(teamData);
  useEffect(() => {
    setShownData(teamData);
  }, [teamData]);

  const parsedDataContent = isLoading ? (
    <SectionLoader />
  ) : !!shownData && shownData?.length > 0 ? (
    <>
      <div className={styles.cardsContainer}>
        {shownData?.slice(0, isTeamMemberShown ? shownData?.length : 6).map((item, index) => {
          const itemTitle = item.firstName + " " + item.lastName + "\n" + item.title;
          return (
            <div className={styles.teamCard} key={`${item.profilePhotoUrl}${index}`} title={itemTitle}>
              <div className={styles.subTeamCardContainer}>
                {item.profilePhotoUrl ? (
                  <img
                    className={styles.imageContainer}
                    src={item.profilePhotoUrl}
                    onError={() => {
                      setShownData((prev) => prev?.map((i) => (i === item ? { ...i, profilePhotoUrl: "" } : i)));
                    }}
                    alt=""
                  />
                ) : (
                  <div className={styles.imageContainer}>
                    <UserIcon className={styles.userIcon} />
                  </div>
                )}
                <div className={styles.infoContainer}>
                  <div className={styles.nameContainer}>
                    <Typography variant="label-4" color="greyscale900">
                      {item.firstName} {item.lastName}
                    </Typography>
                  </div>
                  <Typography variant="body-3" color="greyscale600" className={styles.title}>
                    {item.title}
                  </Typography>
                </div>
              </div>
              {item.linkedInUrl && (
                <a className={styles.linkedInIcon} href={item.linkedInUrl} target="_blank" rel="noreferrer">
                  <LinkedInLettersIcon />
                </a>
              )}
            </div>
          );
        })}
      </div>
      {shownData?.length > 6 && (
        <NormalButton
          variant="primary"
          size="small"
          color="greyscale100"
          className={styles.seeMoreBtn}
          onClick={() => setIsTeamMemberShown((prev) => !prev)}
        >
          <CaretDownIcon className={clsx(styles.caretDownIcon, isTeamMemberShown && styles.seeMoreBtnIconActive)} />
          {isTeamMemberShown ? "Hide" : "Show more"}
        </NormalButton>
      )}
    </>
  ) : (
    <InnoveraBlockNoData />
  );
  return (
    <SectionContentWrapper isByInnovera onReportError={onReportError} companyName="Crunchbase">
      {parsedDataContent}
    </SectionContentWrapper>
  );
}
